var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15039 22.75C4.74039 22.75 4.40039 22.41 4.40039 22V2C4.40039 1.59 4.74039 1.25 5.15039 1.25C5.56039 1.25 5.90039 1.59 5.90039 2V22C5.90039 22.41 5.56039 22.75 5.15039 22.75Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3504 16.75H5.15039C4.74039 16.75 4.40039 16.41 4.40039 16C4.40039 15.59 4.74039 15.25 5.15039 15.25H16.3504C17.4404 15.25 17.9504 14.96 18.0504 14.71C18.1504 14.46 18.0004 13.9 17.2204 13.13L16.0204 11.93C15.5304 11.5 15.2304 10.85 15.2004 10.13C15.1704 9.37 15.4704 8.62 16.0204 8.07L17.2204 6.87C17.9604 6.13 18.1904 5.53 18.0804 5.27C17.9704 5.01 17.4004 4.75 16.3504 4.75H5.15039C4.73039 4.75 4.40039 4.41 4.40039 4C4.40039 3.59 4.74039 3.25 5.15039 3.25H16.3504C18.5404 3.25 19.2404 4.16 19.4704 4.7C19.6904 5.24 19.8404 6.38 18.2804 7.94L17.0804 9.14C16.8304 9.39 16.6904 9.74 16.7004 10.09C16.7104 10.39 16.8304 10.66 17.0404 10.85L18.2804 12.08C19.8104 13.61 19.6604 14.75 19.4404 15.3C19.2104 15.83 18.5004 16.75 16.3504 16.75Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.5a86b66de354dd71568b51901eefb376.svg";
export { ForwardRef as ReactComponent };